var divider_viewer_rtlignore_default = {
  "divider-container": "qJ8UC",
  "divider-container--double": "Tfyeo",
  "divider": "T69Dj",
  "divider--single": "hSuKw",
  "divider--double": "RM5sQ",
  "divider--dashed": "CbhJh",
  "divider--dotted": "Wa2ER",
  "divider--small": "Hcf-J",
  "divider--medium": "SdqT7",
  "divider--large": "YWRdM",
  "divider--left": "fYt-g",
  "divider--center": "jUUwv",
  "divider--right": "v2Ics",
  "svgFixerContainer": "eS6Sn",
  "emptyChar": "mfMAo"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
